import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appCharRestriction]'
})
export class CharRestrictionDirective {

  @Input() public appCharRestriction;
  constructor(private el: ElementRef,
              private control: NgControl) { }

  /**
   * Transforms typed text to letters, -, _, and /.
   */
  @HostListener('keyup', ['$event'])
  public onEvent($event: KeyboardEvent): void {
    if (this.appCharRestriction) {
      if (!$event.key.match(this.appCharRestriction)) {
        $event.preventDefault();
      }
      const value = this.el.nativeElement.value;
      if (value) {
        const trimLeftValue = value.trimLeft().replace(/\s+/g, ' ');
        this.control.control.setValue(trimLeftValue.replace(new RegExp(this.appCharRestriction, 'g'), ''));
      }
    }

  }
}
